export default __webpack_public_path__ + "static/media/Graviola-Soft-Bold.044ecb99.otf";